import { takeLatest } from 'redux-saga/effects';

import { PROCESS_UPSERT_USERS } from '../actions';

import { processUpsertUsersSaga } from './esDocumentSaga';

export default [takeLatest(PROCESS_UPSERT_USERS, processUpsertUsersSaga)];
